import React from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import { withStyles } from "@material-ui/core/styles";

import variables from "./../../../values.scss";

const StyledCircularProgress = withStyles({
  root: {
    color: variables.preloaderColor,
  },
})(CircularProgress);

const Preloader = (props) => {
  const { size } = props;

  return (
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
      <StyledCircularProgress size={!!size ? size : 40} />
    </div>
  );
};

export default Preloader;
